PasswordProtect = require("./components/password-protect.js");
KBSidebar = require("./components/sidebar.js");
KBVoting = require("./components/voting.js");

// console.log("toastr: ");
// console.log(toastr);
// Editor = require("./components/editor/editor.js");
Accordion = require("./elements/accordion.js");
KBSearch = require("./components/search.js");

/* Changed also in semantic.js 4400, 4401 */
jQuery.fn.dropdownX = jQuery.fn.dropdown;

var KB = {
    init: function() {
        // jQuery.noConflict();
        PasswordProtect.load();
        KBSidebar.init();
        KBVoting.init();
        KBSearch.init();
        // Editor.init();
        Accordion.init();
        // this.helpieSyntaxHighlight();
        this.eventHandlers();
    },

    eventHandlers: function() {
        thisModule = this;

        jQuery(".helpie-main-content-area ul.main-nav li a").click(function() {
            jQuery(".helpie-main-content-area ul.main-nav li").removeClass(
                "active"
            );
            jQuery(this)
                .closest("li")
                .addClass("active");
            jQuery(".helpie-main-content-area .content-section").hide();
            jQuery(jQuery(this).data("target")).show();
        });

        jQuery(".category-sidebar ul li a").click(function() {
            jQuery(".category-sidebar ul li").removeClass("active");
            jQuery(this)
                .closest("li")
                .addClass("active");
            jQuery(".category-main-content .category-section").hide();
            jQuery(jQuery(this).data("target")).show();
        });

        // Frontend Editor button Dropdown semantic UI initialization on frontend
        jQuery(".ui.dropdown").dropdownX();
    }
};

module.exports = KB;
